/* istanbul ignore file */

export const FREE_UK_DELIVERY = 'Free UK Delivery';
export const PRODUCT_UNAVAILABLE = 'Out of stock';
export const NEW = 'New';
export const ARRIVES_BY = 'Arrives by ';
